export const categoryData = {
  'star-scandal': {
    name: '明星黑料',
    description: '实时追踪娱乐圈一线明星、顶流艺人、影视歌三栖明星的各类黑料与负面新闻，包括但不限于私生活混乱、偷税漏税、违法违纪、人设崩塌等劲爆内容。',
    icon: 'ri-star-line',
    count: 2340,
    bannerImage: 'https://readdy.ai/api/search-image?query=Dramatic%20red%20carpet%20event%20scene%20with%20paparazzi%20cameras%20flashing%20and%20crowded%20atmosphere%20celebrity%20event%20with%20dark%20dramatic%20lighting%20cinematic%20photography%20style%20luxury%20vibe&width=1200&height=500&seq=cat-banner-01&orientation=landscape',
  },
  'influencer-gossip': {
    name: '网红吃瓜',
    description: '聚焦抖音、快手、小红书、B站等平台头部网红大V的最新八卦动态，包含恋情曝光、直播事故、带货翻车、人设崩塌等劲爆内容，吃瓜群众的欢乐源泉。',
    icon: 'ri-user-smile-line',
    count: 1890,
    bannerImage: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20lifestyle%20scene%20with%20smartphone%20and%20ring%20light%20setup%20modern%20apartment%20interior%20with%20trendy%20decor%20warm%20ambient%20lighting%20cinematic%20style&width=1200&height=500&seq=cat-banner-02&orientation=landscape',
  },
  'daily-contest': {
    name: '每日大赛',
    description: '51爆料独家举办的每日爆料大赛，汇集当日最热门、最劲爆、最令人震惊的各类爆料信息。每天更新最热榜单，让你不错过任何一个大瓜。',
    icon: 'ri-fire-line',
    count: 1560,
    bannerImage: 'https://readdy.ai/api/search-image?query=Dramatic%20competition%20stage%20with%20spotlight%20and%20golden%20trophy%20atmosphere%20show%20business%20event%20with%20audience%20silhouettes%20cinematic%20photography%20style%20warm%20golden%20tones&width=1200&height=500&seq=cat-banner-03&orientation=landscape',
  },
  'video-leak': {
    name: '视频爆料',
    description: '汇集各类独家爆料视频，包括明星网红监控视频、偷拍视频、直播录屏回放等第一手影像资料。有图有真相，视频更劲爆！',
    icon: 'ri-vidicon-line',
    count: 980,
    bannerImage: 'https://readdy.ai/api/search-image?query=Cinematic%20video%20camera%20setup%20in%20dark%20studio%20with%20dramatic%20lighting%20and%20film%20reels%20professional%20video%20production%20atmosphere%20warm%20and%20cool%20tone%20contrast&width=1200&height=500&seq=cat-banner-04&orientation=landscape',
  },
  'live-stream-fail': {
    name: '直播翻车',
    description: '实时追踪各大平台头部主播直播翻车现场，包括假货问题、价格欺诈、言论不当、直播间事故等精彩内容。看主播如何花式翻车！',
    icon: 'ri-live-line',
    count: 720,
    bannerImage: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20setup%20with%20dramatic%20lighting%20and%C2%A0streaming%20equipment%20modern%20technology%20atmosphere%20with%20screens%20and%20cameras%20cinematic%20photography%20style%20dark%20moody%20tones&width=1200&height=500&seq=cat-banner-05&orientation=landscape',
  },
  'romance-exposed': {
    name: '恋情曝光',
    description: '明星网红恋情实锤大合集！提供最新最全的明星网红恋情曝光资讯，高清同框照、甜蜜互动视频、圈内人证实等一手猛料应有尽有。',
    icon: 'ri-heart-pulse-line',
    count: 650,
    bannerImage: 'https://readdy.ai/api/search-image?query=Romantic%20night%20scene%20with%20soft%20bokeh%20lights%20and%20mysterious%20atmosphere%20urban%20cityscape%20at%20night%20with%20warm%20street%20lamps%20cinematic%20photography%20style%20intimate%20mood&width=1200&height=500&seq=cat-banner-06&orientation=landscape',
  },
};

export const categoryArticles = {
  'star-scandal': [
    {
      id: 101,
      slug: 'star-scandal-tax-probe',
      title: '某一线女星涉嫌通过海外账户转移资产，金额高达2亿',
      excerpt: '税务稽查部门发现该女星通过设立海外空壳公司，将片酬收入转移至境外账户，涉嫌严重的逃税行为。',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20bank%20vault%20interior%20with%20dramatic%20lighting%20and%20mysterious%20atmosphere%20wealth%20concept%20with%20shadows%20and%20contrast%20cinematic%20photography%20style&width=600&height=400&seq=cat-art-01&orientation=landscape',
      publishedAt: '2026-07-07T09:00:00',
      views: 890000,
    },
    {
      id: 102,
      slug: 'star-scandal-secret-marriage',
      title: '实力派男演员隐婚五年，妻子竟是圈内知名经纪人',
      excerpt: '据可靠消息，该男演员早在五年前就已秘密登记结婚，妻子是行业内颇有影响力的经纪人，两人一直对外保持单身人设。',
      image: 'https://readdy.ai/api/search-image?query=Secret%20wedding%20ceremony%20concept%20with%20dramatic%20shadows%20and%20mysterious%20atmosphere%20elegant%20interior%20with%20dim%20lighting%20cinematic%20photography%20style&width=600&height=400&seq=cat-art-02&orientation=landscape',
      publishedAt: '2026-07-06T15:00:00',
      views: 675000,
    },
    {
      id: 103,
      slug: 'star-scandal-plastic-surgery',
      title: '当红小花承认整容，前后对比照曝光变化太大',
      excerpt: '该女星在最新采访中首次承认进行过多次整容手术，并公开了部分术前术后对比照片，引发网友热议。',
      image: 'https://readdy.ai/api/search-image?query=Beauty%20clinic%20modern%20interior%20with%20soft%20lighting%20and%20mirrors%20elegant%20atmosphere%20with%20medical%20aesthetic%20vibe%20cinematic%20photography%20style%20clean%20professional%20setting&width=600&height=400&seq=cat-art-03&orientation=landscape',
      publishedAt: '2026-07-06T12:00:00',
      views: 560000,
    },
    {
      id: 104,
      slug: 'star-scandal-director-affair',
      title: '知名导演与女主演剧组暧昧，原配妻子片场抓包',
      excerpt: '某剧组拍摄期间爆发惊天丑闻，导演与女主角在酒店私会被原配当场撞破，整个剧组陷入尴尬。',
      image: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20with%20dramatic%20tension%20atmosphere%20movie%20production%20equipment%20in%20background%20cinematic%20lighting%20with%20shadows&width=600&height=400&seq=cat-art-04&orientation=landscape',
      publishedAt: '2026-07-05T20:00:00',
      views: 780000,
    },
    {
      id: 105,
      slug: 'star-scandal-drug-arrest',
      title: '前选秀冠军涉毒被警方带走，现场搜出大量违禁品',
      excerpt: '警方接到线报后突击检查某高档公寓，当场抓获前选秀冠军及其同伙，现场搜出多种违禁药物。',
      image: 'https://readdy.ai/api/search-image?query=Police%20raid%20scene%20at%20night%20with%20dramatic%20blue%20and%20red%20lights%20urban%20apartment%20building%20exterior%20tense%20atmosphere%20cinematic%20photography%20style&width=600&height=400&seq=cat-art-05&orientation=landscape',
      publishedAt: '2026-07-05T08:00:00',
      views: 920000,
    },
    {
      id: 106,
      slug: 'star-scandal-brand-betrayal',
      title: '代言人劈腿竞争对手品牌，千万违约金面临索赔',
      excerpt: '某品牌代言人在合约期内私下为竞品站台，被品牌方抓个正着，面临千万级别的违约金追讨。',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20boardroom%20with%20dramatic%20lighting%20and%20tense%20negotiation%20atmosphere%20modern%20office%20setting%20with%20shadows%20cinematic%20photography%20style&width=600&height=400&seq=cat-art-06&orientation=landscape',
      publishedAt: '2026-07-04T18:00:00',
      views: 430000,
    },
  ],
  'influencer-gossip': [
    {
      id: 201,
      slug: 'influencer-fake-products',
      title: '千万粉丝美妆博主直播卖假货，粉丝维权群已超5000人',
      excerpt: '多名粉丝反映在该博主直播间购买的护肤品使用后出现严重过敏反应，经检测为假冒伪劣产品。',
      image: 'https://readdy.ai/api/search-image?query=Beauty%20products%20layout%20with%20dramatic%20comparison%20between%20authentic%20and%20fake%20products%20modern%20studio%20setting%20with%20soft%20lighting%20cinematic%20style&width=600&height=400&seq=inf-art-01&orientation=landscape',
      publishedAt: '2026-07-07T11:00:00',
      views: 670000,
    },
    {
      id: 202,
      slug: 'influencer-fake-followers',
      title: '头部网红被曝买粉，真实粉丝数竟不足显示的十分之一',
      excerpt: '第三方数据机构分析发现，该网红账号存在大量僵尸粉和机器粉，真实活跃粉丝比例极低。',
      image: 'https://readdy.ai/api/search-image?query=Social%20media%20analytics%20dashboard%20concept%20with%20dramatic%20data%20visualization%20modern%20tech%20atmosphere%20dark%20mode%20interface%20style&width=600&height=400&seq=inf-art-02&orientation=landscape',
      publishedAt: '2026-07-06T14:00:00',
      views: 540000,
    },
    {
      id: 203,
      slug: 'influencer-cheating-scandal',
      title: '网红情侣分手撕破脸，互爆黑料尺度之大令人咋舌',
      excerpt: '百万粉丝网红情侣突然宣布分手，随后两人在社交平台互相揭短，曝光了大量对方的不堪往事。',
      image: 'https://readdy.ai/api/search-image?query=Broken%20heart%20concept%20with%20dramatic%20split%20composition%20and%20emotional%20tension%20dark%20moody%20atmosphere%20with%20warm%20accents%20cinematic%20photography&width=600&height=400&seq=inf-art-03&orientation=landscape',
      publishedAt: '2026-07-06T09:00:00',
      views: 820000,
    },
    {
      id: 204,
      slug: 'influencer-charity-scam',
      title: '网红公益直播疑似作秀，捐款去向成谜引质疑',
      excerpt: '某网红举办的慈善直播活动中，承诺的捐款金额与实际到账存在巨大差距，相关部门已介入调查。',
      image: 'https://readdy.ai/api/search-image?query=Charity%20event%20scene%20with%20dramatic%20lighting%20and%20question%20marks%20concept%20fundraising%20atmosphere%20with%20mysterious%20tone%20cinematic%20photography%20style&width=600&height=400&seq=inf-art-04&orientation=landscape',
      publishedAt: '2026-07-05T16:00:00',
      views: 480000,
    },
  ],
  'daily-contest': [
    {
      id: 301,
      slug: 'daily-contest-top-scandal-week',
      title: '本周最劲爆黑料TOP10：第一名让整个娱乐圈地震',
      excerpt: '本周爆料大赛竞争激烈，从明星吸毒到导演潜规则，每一条都让人瞠目结舌。第一名更是牵涉多位一线艺人。',
      image: 'https://readdy.ai/api/search-image?query=Dramatic%20ranking%20list%20concept%20with%20golden%20trophy%20and%20spotlight%20competition%20atmosphere%20dark%20background%20with%20glowing%20accents%20cinematic%20style&width=600&height=400&seq=dc-art-01&orientation=landscape',
      publishedAt: '2026-07-07T07:00:00',
      views: 1200000,
    },
    {
      id: 302,
      slug: 'daily-contest-fan-war',
      title: '粉丝大战升级：两大顶流粉丝24小时屠版互撕全记录',
      excerpt: '起因只是一条微博评论，最终演变成涉及数百万粉丝的全网混战，连明星本人都被卷入其中。',
      image: 'https://readdy.ai/api/search-image?query=Social%20media%20war%20concept%20with%20dramatic%20versus%20composition%20and%20explosive%20atmosphere%20digital%20battlefield%20with%20bright%20and%20dark%20contrast&width=600&height=400&seq=dc-art-02&orientation=landscape',
      publishedAt: '2026-07-06T11:00:00',
      views: 950000,
    },
    {
      id: 303,
      slug: 'daily-contest-gossip-king',
      title: '吃瓜之王出炉：这位线人连续三个月提供独家猛料',
      excerpt: '51爆料内部评选出本季度最强线人，该线人在三个月内提供了超过50条独家爆料，准确率高达98%。',
      image: 'https://readdy.ai/api/search-image?query=Mysterious%20informant%20concept%20with%20silhouette%20and%20documents%20dramatic%20lighting%20shadow%20figure%20in%20dark%20room%20cinematic%20spy%20thriller%20style&width=600&height=400&seq=dc-art-03&orientation=landscape',
      publishedAt: '2026-07-05T10:00:00',
      views: 680000,
    },
  ],
};

export const categorySubTags = {
  'star-scandal': [
    { name: '偷税漏税', slug: 'tax-evasion', icon: 'ri-money-cny-circle-line' },
    { name: '私生活混乱', slug: 'private-life', icon: 'ri-moon-line' },
    { name: '违法违纪', slug: 'illegal', icon: 'ri-police-car-line' },
    { name: '人设崩塌', slug: 'persona-collapse', icon: 'ri-ghost-line' },
    { name: '行业内幕', slug: 'industry-insider', icon: 'ri-eye-line' },
    { name: '合约纠纷', slug: 'contract-dispute', icon: 'ri-file-text-line' },
  ],
  'influencer-gossip': [
    { name: '直播翻车', slug: 'live-fail', icon: 'ri-live-line' },
    { name: '带货造假', slug: 'fake-sales', icon: 'ri-shopping-bag-line' },
    { name: '粉丝纠纷', slug: 'fan-dispute', icon: 'ri-group-line' },
    { name: '恋情曝光', slug: 'romance', icon: 'ri-heart-line' },
    { name: '假货问题', slug: 'fake-products', icon: 'ri-alert-line' },
    { name: '数据造假', slug: 'fake-data', icon: 'ri-bar-chart-line' },
  ],
  'daily-contest': [
    { name: '今日最热', slug: 'hottest-today', icon: 'ri-fire-line' },
    { name: '本周排行', slug: 'weekly-rank', icon: 'ri-trophy-line' },
    { name: '月度盘点', slug: 'monthly-review', icon: 'ri-calendar-check-line' },
    { name: '粉丝大战', slug: 'fan-war', icon: 'ri-sword-line' },
    { name: '独家首发', slug: 'exclusive', icon: 'ri-vip-crown-line' },
    { name: '网友投稿', slug: 'user-submit', icon: 'ri-mail-send-line' },
  ],
  'video-leak': [
    { name: '监控视频', slug: 'surveillance', icon: 'ri-camera-line' },
    { name: '偷拍视频', slug: 'paparazzi', icon: 'ri-camera-lens-line' },
    { name: '直播录屏', slug: 'stream-record', icon: 'ri-record-circle-line' },
    { name: '综艺片段', slug: 'variety-clip', icon: 'ri-tv-line' },
  ],
};